import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { Button } from "@mui/material";

import { ControlledButtonHook } from "commons/hooks/useControlledButton";

type PropsType = {
    readonly tablePagination?: JSX.Element;
    readonly extraButtons?: JSX.Element;
    readonly exportXlsxListButton?: ControlledButtonHook;
    readonly dontShowExportXlsxButton?: boolean;
    readonly colSpan: number;
};

function TableFooter({
    tablePagination,
    extraButtons,
    exportXlsxListButton,
    colSpan,
    dontShowExportXlsxButton,
}: PropsType) {
    return (
        <tfoot>
            <tr>
                <td colSpan={colSpan}>
                    <div className={"table-footer"}>
                        <div className={"table-footer-pagination"}>{tablePagination}</div>

                        {exportXlsxListButton && dontShowExportXlsxButton !== true && (
                            <div>
                                <Button
                                    variant={"contained"}
                                    color={"primary"}
                                    startIcon={<FileDownloadIcon />}
                                    {...exportXlsxListButton}
                                >
                                    {"Esporta elenco"}
                                </Button>
                            </div>
                        )}

                        <div>{extraButtons}</div>
                    </div>
                </td>
            </tr>
        </tfoot>
    );
}

export default TableFooter;
